"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TooltipScreen = TooltipScreen;
var _kbd = require("@design/ui/kbd");
var _tooltip = require("./tooltip.wiring");
var _jsxRuntime = require("react/jsx-runtime");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function TooltipScreen() {
  var _w$tooltipShowCaret, _w$tooltipLabel, _w$tooltipShowKbd, _w$kbdShowLeftIcon, _w$kbdLabel, _w$kbdShowRightIcon;
  var w = (0, _tooltip.useWiring)();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    style: {
      display: "flex",
      flexDirection: "row",
      gap: "6px",
      justifyContent: "center",
      alignItems: "center",
      padding: "6px 12px 6px 12px",
      maxWidth: "160px",
      backgroundColor: "rgba(250, 249, 247, 1)",
      border: "1px solid rgba(242, 240, 233, 1)",
      borderRadius: "8px",
      boxShadow: "0px 4px 6px -1px rgba(0, 0, 0, 0.05), 0px 2px 4px -2px rgba(0, 0, 0, 0.05)"
    },
    "data-sentry-component": "TooltipScreen",
    "data-sentry-source-file": "tooltip.tsx",
    children: [((_w$tooltipShowCaret = w.tooltipShowCaret) !== null && _w$tooltipShowCaret !== void 0 ? _w$tooltipShowCaret : true) ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      style: {
        width: "14.142135381698608px",
        height: "14.142135381698608px",
        backgroundColor: "rgba(250, 249, 247, 1)",
        border: "1px solid rgba(242, 240, 233, 1)",
        borderRadius: "2px"
      }
    }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      style: {
        flexGrow: "1",
        flexBasis: "auto",
        minWidth: "0",
        color: "rgba(28, 25, 23, 1)",
        fontFamily: "Inter",
        fontSize: "12px",
        fontWeight: "400",
        lineHeight: "16px",
        letterSpacing: "0.12px"
      },
      children: (_w$tooltipLabel = w.tooltipLabel) !== null && _w$tooltipLabel !== void 0 ? _w$tooltipLabel : "Selected Workspace Name that is very very long and very long indeed"
    }), ((_w$tooltipShowKbd = w.tooltipShowKbd) !== null && _w$tooltipShowKbd !== void 0 ? _w$tooltipShowKbd : false) ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_kbd.Kbd, _objectSpread(_objectSpread({}, w.kbd), {}, {
      className: "bg-foreground text-background",
      children: [((_w$kbdShowLeftIcon = w.kbdShowLeftIcon) !== null && _w$kbdShowLeftIcon !== void 0 ? _w$kbdShowLeftIcon : false) ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: {
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          width: "16px",
          height: "12px"
        },
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          style: {
            alignSelf: "stretch",
            flexGrow: "1",
            flexBasis: "0",
            minHeight: "0"
          },
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            style: {
              backgroundColor: "rgba(142, 138, 131, 1)"
            }
          })
        })
      }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        style: {
          color: "rgba(250, 249, 247, 1)",
          fontFamily: "Inter",
          fontSize: "14px",
          fontWeight: "400",
          lineHeight: "20px",
          textAlign: "center"
        },
        children: (_w$kbdLabel = w.kbdLabel) !== null && _w$kbdLabel !== void 0 ? _w$kbdLabel : "S"
      }), ((_w$kbdShowRightIcon = w.kbdShowRightIcon) !== null && _w$kbdShowRightIcon !== void 0 ? _w$kbdShowRightIcon : false) ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: {
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          width: "16px",
          height: "12px"
        },
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          style: {
            alignSelf: "stretch",
            flexGrow: "1",
            flexBasis: "0",
            minHeight: "0"
          },
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            style: {
              backgroundColor: "rgba(142, 138, 131, 1)"
            }
          })
        })
      }) : null]
    })) : null]
  });
}